import { render, staticRenderFns } from "./RegistrationInspection.vue?vue&type=template&id=7e4cbf1c&scoped=true"
import script from "./RegistrationInspection.vue?vue&type=script&lang=js"
export * from "./RegistrationInspection.vue?vue&type=script&lang=js"
import style0 from "./RegistrationInspection.vue?vue&type=style&index=0&id=7e4cbf1c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e4cbf1c",
  null
  
)

export default component.exports